import React from "react";

const About = () => (
      <div>
            About Netwips
      </div>
  )

  export default About;

